import { openDB } from "idb";

export const dbPromise = openDB("appDB", 1, {
  upgrade(db) {
    if (!db.objectStoreNames.contains("messages")) {
      db.createObjectStore("messages");
    }
  },
});

export const getStoreData = async <T>(
  storeName: string,
  key: IDBValidKey
): Promise<T | null> => {
  const db = await dbPromise;
  return (await db.get(storeName, key)) || null;
};

export const putStoreData = async <T>(
  storeName: string,
  key: string,
  data: T
) => {
  const db = await dbPromise;
  await db.put(storeName, data, key);
};

export const getAllStoreKeys = async (
  storeName: string
): Promise<IDBValidKey[]> => {
  const db = await dbPromise;
  return db.getAllKeys(storeName);
};
